import {setError} from "./error";

export const SET_USER = '@set-user';
export const SET_USER_LANG = '@set-user-lang';
export const SET_EDITABLE = '@set-editable';
export const SOCKET_CONNECTED = '@socket-connected';
export const SET_USER_ERRORS = '@set-user-errors';
export const SET_LOADING = '@set-loading';
import http from "../../libs/http";
import {User} from "../../libs/models";

export const setUser = (payload) => {
    return {
        payload,
        type: SET_USER
    };
};

export const setUserErrors = (payload) => {
    return {
        payload,
        type: SET_USER_ERRORS
    };
};

export const setLoading = (payload) => {
    return {
        payload,
        type: SET_LOADING
    };
};

export const getUser = () => {
    return async (dispatch) => {
        try {
            const res = await http.route('user').get();

            if (!res.isError) {
                dispatch(setUser(new User(res.data)));
                dispatch(setUserErrors(false));
                dispatch(setLoading(false));
            } else {
                dispatch(setUserErrors(res.errorMessage));
            }
        } catch (e) {
            dispatch(setError(e.message));
        }
    };
};

export default {
    setUser,
    setUserErrors,
    setLoading,
    getUser
}